import { isBrowser } from '../constants';
import { publicApi } from './index';

export const getAnalyticsAPI = async (fileUuid: string) => {
  return publicApi.get(
    `file/${fileUuid}/analytics`,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      : {}
  );
};
